import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMyAgahDark = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={84} height={16} fill='none' {...props}>
    <g fill='#fff' clipPath='url(#myAgah-dark_svg__a)'>
      <path d='m72.102 5.993-10.003.011L72.288.011 66.35.022l-10.2 5.993-.011 3.992h13.629c.186 0 .329.143.329.33v1.65s0 .01-.011.01l-15.602-.033a.323.323 0 0 1-.328-.33l-.011-9.765c0-.527.01-1.88.01-1.88h-4.459s-.01 0-.01.011v4.069l.493.484-.022 9.446c0 1.088.887 1.979 1.972 1.979h21.934c.01-1.22.01-5.476.01-8.027a1.963 1.963 0 0 0-1.971-1.958M39.76 7.995h3.943v3.958H39.77zh-3.978V16l9.96-.01c1.084 0 1.971-.892 1.971-1.98V4.003H39.77z' />
      <path d='M72.069 2.012v3.464h3.966V4.003h5.982c1.085 0 1.972-.891 1.972-1.98V.022l-9.948.011c-1.096 0-1.972.88-1.972 1.98M76.057 6.004l-.011 9.985h2.07a1.91 1.91 0 0 0 1.907-1.913V6.004s-3.144-.01-3.966 0M61.464 0 56.15 3.101v2.298L65.386 0z' />
      <path fillRule='evenodd' d='M5.982 4.003v2.001h3.966V4.003z' clipRule='evenodd' />
      <path d='M29.833 3.992h-9.948v7.983H15.93V4.014h-3.977v7.961H4.306a.323.323 0 0 1-.329-.33V4.003H0V14.02C0 15.109.887 16 1.972 16H15.92v-1.892a1.977 1.977 0 0 0 1.972 1.88l11.942-.022c1.085 0 1.972-.89 1.972-1.98V5.96a1.965 1.965 0 0 0-1.972-1.968m-2.027 7.94h-3.933v-3.96h3.933z' />
    </g>
    <defs>
      <clipPath id='myAgah-dark_svg__a'>
        <path fill='#fff' d='M0 0h84v16H0z' />
      </clipPath>
    </defs>
  </svg>
);
export default SvgMyAgahDark;
